export const getStringToIBAN = (iban: string): string => iban.replace(/[- ]/g, '').toUpperCase();
